import { render, staticRenderFns } from "./mtAuth.vue?vue&type=template&id=3249a036&scoped=true"
import script from "./mtAuth.vue?vue&type=script&lang=js"
export * from "./mtAuth.vue?vue&type=script&lang=js"
import style0 from "./mtAuth.vue?vue&type=style&index=0&id=3249a036&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3249a036",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3249a036')) {
      api.createRecord('3249a036', component.options)
    } else {
      api.reload('3249a036', component.options)
    }
    module.hot.accept("./mtAuth.vue?vue&type=template&id=3249a036&scoped=true", function () {
      api.rerender('3249a036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/mtAuth.vue"
export default component.exports